import ValidationHelper from 'legacy/lut/classes/helpers/partner360/ValidationHelper'
import { selectJbpSettingsRoleOptions } from 'legacy/lut/features/partner360/jbpSettings/selectors/selectJbpSettingsRoleOptions'
import { FC, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { FormDropdown } from 'cng-common/features/form'
import { useStaticCrud } from 'core-components/types/helpers'

import { HP_CONTACT_REQUEST_EDITOR_FORM } from '../../config'

export interface IRoleSelectionDropdownProps {
  defaultValue: string
  isRequestAccess?: boolean
  disabled?: boolean
}

export const RoleSelectionDropdown: FC<IRoleSelectionDropdownProps> = ({
  defaultValue,
  isRequestAccess,
  disabled,
}) => {
  const options = useSelector(selectJbpSettingsRoleOptions)
  const allRolesCrud = useStaticCrud({
    data: options,
    keyField: 'Role',
    displayField: 'Role',
    pageSize: options.length,
  })

  const validateNotEmpty = (value: string): Promise<string> => {
    return Promise.resolve(value && value.length > 0 ? '' : 'Please, select a value')
  }

  const checkFn = useCallback(
    (value: string) => {
      return isRequestAccess
        ? validateNotEmpty(value)
        : ValidationHelper.checkDropdown(value, options, 'Role')
    },
    [options, isRequestAccess]
  )

  return (
    <FormDropdown
      formKey={HP_CONTACT_REQUEST_EDITOR_FORM}
      field="Roles"
      label="Roles"
      caption="Role"
      defaultValue={defaultValue}
      source={allRolesCrud as any}
      checkFn={checkFn}
      disabled={disabled}
    />
  )
}
